// import update from "immutability-helper";
import {
  SET_FROM_MAPPING,
  SET_RESOURCES_LIST,
  UPDATE_FROM_MAPPING_FIELDS,
  REMOVE_FROM_MAPPING_FIELD,
  SET_TO_PAGES,
  SET_TO_MAPPING,
  UPDATE_TO_MAPPING_FIELDS,
  SET_TO_PAGE_CONDITION,
  REMOVE_TO_MAPPING_FIELD,
  CLEAR_PAGES_CONFIG,
  REMOVE_TO_PAGES,
  UPDATE_TO_PAGE,
  LOAD_CONFIG_COLLECTION,
  SET_ACTIVE_CONFIG_PAGE,
  REMOVE_ACTIVE_POPUP_PAGE,
  SET_RESOURCES_LIST_BY_TYPE,
  UPDATE_PAGE_FLOWS_DATA,
  RESTORE_PAGE_FLOWS,
  SET_HISTORY_PAGE_FLOWS,
  GO_TO_HISTORY_PAGE_FLOWS,
  UPDATE_PAGE_DATA_BY_KEY,
  LOAD_CONFIG_COLLECTION_SILENT,
  REMOVE_HISTORY_PAGE_BY_KEY,
  SET_WINDOW_VARIABLE_LIST,
  CLEAR_HISTORY_PAGE_FLOWS
} from "../actionTypes/PagesActionTypes";
import { isSet } from "../../Utils/CommonFunctions";
// import { stat } from "fs-extra";

const initialState = {
  pagesConfiguration:{
    from_page_mapping: [],
    to_page_mapping: []
  },
   resourcesList:{
    input:[],
    output:[],
    constants:[],
    variables:[],
    resources:[]
  },
  pageFlows:{
    activePage: null,  //ActivePage is single
    activePopups: [], //activePopups
    activeToPages:[],
    history: [], //History API Names/IDs
    windowVariableList: {},
    pageData: {}
  }
};

// Assign the reducer function to a named variable
const PagesReducer = (state = initialState, action) => {
  const { pagesConfiguration,resourcesList,pageFlows } = state;
  const { payload, type } = action;
  let updatePagesConfigState = null,toPageMapping=null,fromPageMapping=null,updateResourcesList=null,updatePageFlows=null;

  switch (type) {
    case CLEAR_PAGES_CONFIG:
      return{
        ...state,
        pagesConfiguration: { 
          from_page_mapping: [],
          to_page_mapping: []
        },
      }
    case SET_FROM_MAPPING:
      fromPageMapping = [
       ...pagesConfiguration.from_page_mapping,
        ...payload,
      ];
      return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          from_page_mapping:fromPageMapping 
        },
      };
    case UPDATE_FROM_MAPPING_FIELDS:
      const {fromIndex,fromValue} = payload;
      fromPageMapping = pagesConfiguration.from_page_mapping.map((item, index) =>
      index === fromIndex ? { ...item, ...fromValue } : item
    );
      return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          from_page_mapping:fromPageMapping 
        },
      };
    case REMOVE_FROM_MAPPING_FIELD:
      const {fromRemoveIndex} = payload;
      fromPageMapping = pagesConfiguration.from_page_mapping.filter(
        (_, index) => index !== fromRemoveIndex
      );
      return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          from_page_mapping:fromPageMapping 
        },
      };
    case SET_TO_PAGES:
      /**
       * Merge/dedupe incoming "to pages" payload into existing list.
       *
       * Why: `setToPagesAction` is used both for "append pages" and for ensuring
       * the SAME_PAGE placeholder exists. The old reducer always appended,
       * allowing duplicates (especially SAME_PAGE) after reload/save flows.
       *
       * Strategy:
       * - Identify pages by stable key: `page_id` (preferred) else `page_name`
       * - If a page already exists, merge shallow props but do NOT overwrite
       *   existing `condition` / `field_mappings` with empty arrays.
       */
      {
        const incoming = Array.isArray(payload) ? payload : [];
        const existing = Array.isArray(pagesConfiguration.to_page_mapping)
          ? pagesConfiguration.to_page_mapping
          : [];

        const keyOf = (p) => isSet(p?.page_id, '') || isSet(p?.page_name, '');

        toPageMapping = [...existing];
        incoming.forEach((next) => {
          const nextKey = keyOf(next);
          if (!nextKey) return;

          const idx = toPageMapping.findIndex((p) => keyOf(p) === nextKey);
          if (idx === -1) {
            toPageMapping.push({
              ...next,
              redirect: next?.redirect !== undefined ? next.redirect : null,
            });
            return;
          }

          const prev = toPageMapping[idx] || {};
          const nextCondition = Array.isArray(next?.condition) ? next.condition : null;
          const nextFieldMappings = Array.isArray(next?.field_mappings) ? next.field_mappings : null;

          toPageMapping[idx] = {
            ...prev,
            ...next,
            ...(next.redirect !== undefined ? { redirect: next.redirect } : {}),
            ...(nextCondition ? { condition: nextCondition.length ? nextCondition : isSet(prev.condition, []) } : {}),
            ...(nextFieldMappings
              ? { field_mappings: nextFieldMappings.length ? nextFieldMappings : isSet(prev.field_mappings, []) }
              : {}),
          };
        });
      }
      return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          to_page_mapping:toPageMapping 
        },
      };
    case REMOVE_TO_PAGES:
    const { toPageIndex } = payload;

    return {
      ...state,
      pagesConfiguration: {
        ...pagesConfiguration,
        to_page_mapping: pagesConfiguration.to_page_mapping.filter(
          (_, index) => index !== toPageIndex
        )
      }
    };
    case SET_TO_PAGE_CONDITION:
      // const { pageIndex, newFieldMappings } = payload; // pageIndex = number, newFieldMappings = array
      toPageMapping = pagesConfiguration.to_page_mapping.map((page, index) => {
        if (index === payload.pageIndex) {
          return {
            ...page,
            condition:isSet(payload.condition,[])
          };
        }
        return page; // leave others unchanged
      });
       return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          to_page_mapping:toPageMapping 
        },
      };
    case SET_TO_MAPPING:
      const { pageIndex, newFieldMappings } = payload; // pageIndex = number, newFieldMappings = array
      toPageMapping = pagesConfiguration.to_page_mapping.map((page, index) => {
        if (index === pageIndex) {
          return {
            ...page,
            field_mappings: [
              ...page.field_mappings,
              ...newFieldMappings
            ]
          };
        }
        return page; // leave others unchanged
      });
      return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          to_page_mapping:toPageMapping 
        },
      };
    case REMOVE_TO_MAPPING_FIELD:
      const {toRemoveIndex } = payload; // pageIndex = number, newFieldMappings = array
      toPageMapping = pagesConfiguration.to_page_mapping.map((page, index) => {
        if (index === payload.pageIndex) {
          return {
            ...page,
            field_mappings: [
              ...page.field_mappings.filter(
                  (_, index) => index !== toRemoveIndex
                )
            ]
          };
        }
        return page; // leave others unchanged
      });
    
      return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          to_page_mapping:toPageMapping 
        },
      };
     case UPDATE_TO_MAPPING_FIELDS:
      const { toIndex,toValue } = payload; // pageIndex = number, newFieldMappings = array
        // console.log('toPageMapping',payload);
      toPageMapping = pagesConfiguration.to_page_mapping.map((page, index) => {
        if (index === payload.pageIndex) {
          return {
            ...page,
            field_mappings: [
              ...page.field_mappings.map((item, fieldIndex) =>
                fieldIndex === toIndex ? { ...item, ...toValue } : item
              )
            ]
          };
        }
        return page; // leave others unchanged
      });
    
      return {
        ...state,
        pagesConfiguration: { 
          ...pagesConfiguration,
          to_page_mapping:toPageMapping 
        },
      };
    case UPDATE_TO_PAGE: {
      const { pageIndex, patch } = payload;
      toPageMapping = (pagesConfiguration.to_page_mapping || []).map((page, index) => {
        if (index !== pageIndex) {
          return page;
        }
        const updated = { ...page, ...patch };
        if (patch.page_id !== undefined && Array.isArray(updated.condition)) {
          updated.condition = updated.condition.map((condition) => ({
            ...condition,
            pages_id: patch.page_id,
          }));
        }
        return updated;
      });
      return {
        ...state,
        pagesConfiguration: {
          ...pagesConfiguration,
          to_page_mapping: toPageMapping
        }
      };
    }
      
    case SET_RESOURCES_LIST:
        updateResourcesList = {
              ...resourcesList,
              ...payload
        }
        return{
          ...state,
          resourcesList:updateResourcesList
        }  
    case SET_RESOURCES_LIST_BY_TYPE:
      const {inputsVar,outputsVar} = payload;
        updateResourcesList = {
              ...resourcesList,
              input:[...resourcesList['input'],...inputsVar],
              output:[...resourcesList['output'],...outputsVar]
        }
        // console.log('updateResourcesList',updateResourcesList);
        return{
          ...state,
          resourcesList:updateResourcesList
        }  
    case RESTORE_PAGE_FLOWS:
      const restorePageData = localStorage.getItem('pageFlows');
      // console.log('restorePageData',restorePageData);
      updatePageFlows = {...pageFlows};
      try{
        const updateFlows = JSON.parse(restorePageData);
        updatePageFlows = updateFlows;
        // console.log('updatePageFlows',updatePageFlows);
      }catch(e){

      }
      return{
        ...state,
        pageFlows:{...updatePageFlows,activePopups:[]}
      }
    // RENDER PAGES BLOCK
    case LOAD_CONFIG_COLLECTION:
      // console.log('payload',payload);
      const {collections} = payload;
      updatePageFlows = {...pageFlows}
      // if(collections?.type==='PAGES'){
      //   updatePageFlows = {
      //     ...updatePageFlows,
      //     pageData:{
      //       ...updatePageFlows?.pageData,
      //       [payload?.configKey]:collections
      //     }
      //   }
      // }else{
        const existingsPageData = isSet(pageFlows.pageData?.[payload?.configKey], {}) || {};
        // console.log('existingsPageData',{
        //       ...existingsPageData,
        //       ...collections,
        //     });
        const mergedPages = (collections && collections.pages)
          ? {
              ...isSet(existingsPageData?.pages, {}),
              ...collections.pages
            }
          : isSet(existingsPageData?.pages, {});

        updatePageFlows = { 
          ...updatePageFlows,
          pageData:{
            ...updatePageFlows?.pageData,
            [payload?.configKey]:{
              ...existingsPageData,
              ...collections,
              ...(collections && collections.pages ? { pages: mergedPages } : {}),
            }
          },
          // invoice_recordId:payload?.identifer?.recordId,
        }
      // }
      
         if(collections?.config_type==='DIRECT'){
          // console.log('collections',collections);
          if(collections?.pages?.display_type==='SAME_WINDOW'){
            // console.log('resourcesList--',payload?.configKey);
            updatePageFlows = {
                ...updatePageFlows,
                activePage:payload?.configKey,
                activePopups:[],// pageFlows?.activePopups.slice(0, -1), //remove if same window and if popup already open.
              }
          }else{
              updatePageFlows = {
                ...updatePageFlows,
                activePopups:[...updatePageFlows?.activePopups,isSet(collections?.configuration_api_name,payload?.configKey)],
              }
          }
        }else if(collections?.type==='PAGES'){
          if(collections?.pages?.display_type==='SAME_WINDOW' || collections?.pages?.display_type==='SEPARATE_WINDOW'){
            let pageFlowsObj = {};
            if(collections?.pages?.display_type==='SAME_WINDOW'){
              pageFlowsObj  = {
                activePage:payload?.configKey,//collections?.configuration_api_name,
              };
            }else if(collections?.pages?.display_type==='SEPARATE_WINDOW'){
              pageFlowsObj  = {
                activeWindowPage:payload?.configKey,//collections?.configuration_api_name,
              };
            }
            updatePageFlows = {
                ...updatePageFlows,
                ...pageFlowsObj,
                // activePopups:[],// pageFlows?.activePopups.slice(0, -1), //remove if same window and if popup already open.
              }
            }else{
                updatePageFlows = {
                  ...updatePageFlows,
                  activePopups:[...updatePageFlows?.activePopups,payload?.configKey],
                }
            }
        }
        console.log('updatePageFlows',updatePageFlows,collections,payload);
        try{
          localStorage.setItem('pageFlows',JSON.stringify(updatePageFlows));
        }catch(e){

        }
     
      return{
        ...state,
        pageFlows:{
          ...updatePageFlows,
        },
      }
      case LOAD_CONFIG_COLLECTION_SILENT: {
        const { collections: silentCollections, configKey: silentKey } = payload;
        updatePageFlows = { ...pageFlows };
        const existingSilentPageData = isSet(pageFlows.pageData?.[silentKey], {}) || {};

        updatePageFlows = {
          ...updatePageFlows,
          pageData: {
            ...updatePageFlows.pageData,
            [silentKey]: {
              ...existingSilentPageData,
              ...silentCollections
            }
          }
        };

        try {
          localStorage.setItem("pageFlows", JSON.stringify(updatePageFlows));
        } catch (e) {
          // ignore storage errors
        }

        return {
          ...state,
          pageFlows: {
            ...updatePageFlows
          }
        };
      }
      case SET_ACTIVE_CONFIG_PAGE:
         const {pageDesignType,pageConfigKey} = payload;
         updatePageFlows = {...pageFlows}
        return{
          ...state,
          pageFlows:{
            ...updatePageFlows,
            activePage:pageConfigKey
          }
        }
      case UPDATE_PAGE_FLOWS_DATA:
        const {configApiName, pageDataKey, pageDataValue} = payload;
        updatePageFlows = {
          ...pageFlows,
          activeToPages:[
            ...pageFlows?.activeToPages,
            {
              configApiName:configApiName,
              pageDataKey:pageDataValue
            }
          ]
        }
        return{
        ...state,
        pageFlows:{
          ...updatePageFlows,
        },
      }
      case UPDATE_PAGE_DATA_BY_KEY: {
        const { configKey, patch, targetKey } = payload || {};
        if (!configKey || !patch || typeof patch !== "object") {
          return state;
        }

        const existingPageData = isSet(pageFlows.pageData?.[configKey], {}) || {};
        let newPageData;
        if (targetKey) {
          const existingNested = isSet(existingPageData[targetKey], {}) || {};
          newPageData = {
            ...existingPageData,
            [targetKey]: {
              ...existingNested,
              ...patch
            }
          };
        } else {
          newPageData = {
            ...existingPageData,
            ...patch
          };
        }

        updatePageFlows = {
          ...pageFlows,
          pageData: {
            ...pageFlows.pageData,
            [configKey]: newPageData
          }
        };

        const collections = newPageData;
        console.log('collections',collections);

        return {
          ...state,
          pageFlows: {
            ...updatePageFlows
          }
        };
      }

      case SET_HISTORY_PAGE_FLOWS:
        updatePageFlows = { ...pageFlows };
        if (
          updatePageFlows.activePage &&
          !isSet(updatePageFlows.history, []).includes(updatePageFlows.activePage)
        ) {
          updatePageFlows = {
            ...updatePageFlows,
            history: [...updatePageFlows.history, updatePageFlows.activePage],
          };
        }
        return {
          ...state,
          pageFlows: { ...updatePageFlows },
        };

      case GO_TO_HISTORY_PAGE_FLOWS:
      updatePageFlows = {...pageFlows};
      const lastPage = updatePageFlows?.history?.at(-1);
      // console.log('updatePageFlows',updatePageFlows);
      updatePageFlows  = {
        ...updatePageFlows,
        history:[...updatePageFlows.history.slice(0, -1)],
        activePage:lastPage
      }
      // console.log('updatePageFlows',updatePageFlows.activePage)
      
      return{
        ...state,
        pageFlows:{...updatePageFlows}
      }
      case CLEAR_HISTORY_PAGE_FLOWS:
        updatePageFlows = { ...pageFlows };
        updatePageFlows = {
          ...updatePageFlows,
          history: [],
        };
        return {
          ...state,
          pageFlows: { ...updatePageFlows },
        };
      case REMOVE_ACTIVE_POPUP_PAGE:
        const {removingConfigKey} = payload;
        updatePageFlows = {
          ...pageFlows,
          activePopups: pageFlows?.activePopups.filter(
            (i) => i !== removingConfigKey
          ),
        };
        return{
          ...state,
          pageFlows:{
            ...updatePageFlows
          }
        }
        case REMOVE_HISTORY_PAGE_BY_KEY: {
          const { configKey } = payload || {};
          updatePageFlows = { ...pageFlows };
        
          const historyArr = isSet(updatePageFlows.history, []);
          const index = historyArr.findIndex((k) => k === configKey);
          // console.log('indexconfigKey', historyArr, index, configKey);
        
          if (index !== -1) {
            updatePageFlows = {
              ...updatePageFlows,
              // keep everything BEFORE currentKey, drop currentKey and tail
              history: historyArr.slice(0, index),
            };
          }
        
          return {
            ...state,
            pageFlows: { ...updatePageFlows },
          };
        }
        case SET_WINDOW_VARIABLE_LIST: {
          const { windowVariableList } = payload || {};
          updatePageFlows = { ...pageFlows };
          updatePageFlows = {
            ...updatePageFlows,
            windowVariableList: {
              ...isSet(updatePageFlows.windowVariableList, {}),
              ...isSet(windowVariableList, {}),
            },
          };
          return {
            ...state,
            pageFlows: { ...updatePageFlows },
          };
        }
      

    // RENDER PAGES BLOCK END
    default:
      return state;
  }
};

// Export the named function as the default export
export default PagesReducer;
